import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Nav } from "./components/site/Nav";
import { Hero } from "./components/site/Hero";
import { About } from "./components/site/About";
import { Products } from "./components/site/Products";
import { Contact } from "./components/site/Contact";
import { LogosPreview } from "./components/site/LogosPreview";

const Home = () => {
    return (
        <main data-testid="home-page" className="min-h-screen bg-white overflow-x-hidden">
            <Nav />
            <Hero />
            <About />
            <Products />
            <Contact />
        </main>
    );
};

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/logos" element={<LogosPreview />} />
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;
